import React, { ReactNode, useEffect } from 'react';

import { LinearProgress } from '@material-ui/core';

import { default as AddIcon } from '@material-ui/icons/Add';
import { default as EditIcon } from '@material-ui/icons/Edit';

import { usePrivileges } from '../../../../../../../state/auth/index.hooks';

import {
    useLocationDetailsLoading,
    useSelectedClientsAndLocations,
} from '../../../../../../../state/ui/customerService/clientsAndLocations/index.hooks';

import {
    enterLocationEditMode,
    enterLocationAddMode,
} from '../../../../../../../state/ui/customerService/bottomGrid';

import { useToolkitDispatch } from '../../../../../../../hooks';

import TranslationHelper from '../../../../../../../helpers/TranslationHelper';

import { useRegistersGroups } from '../../../../../../../state/app/registers/index.hooks';
import { fetchRegistersGroups } from '../../../../../../../state/app/registers/groups';
import {
    prepareGroups,
    prepareVisibilityType,
} from '../../../../../../../components/VisibilityForm/VisibilityForm';
import { useUserDataPermissions } from '../../../../../../../state/user/index.hooks';
import PaneHeader from '../../../../../../../components/PaneHeader';
import { BLANK_FORM_LOCATION } from '../../ClientsAndLocations/blankForms';
import IconButtonWithTooltip from '../../../../../../../components/IconButtonWithTooltip';
import LocationPreviewForm from '../../ClientsAndLocations/LocationPreviewForm';
import { useTaskPaneLoading } from '../../../../../../../state/ui/customerService/bottomGrid/tasks/index.hooks';
import { IServiceLocation } from 'src/app/models/customerService';

interface IOwnProps {
    location: IServiceLocation | null;
    handleClose: () => void;
    titleComponent?: ReactNode;
}

const LocationPane = ({ location, handleClose, titleComponent }: IOwnProps) => {
    const privileges = usePrivileges();
    const locationLoading = useLocationDetailsLoading();

    const paneLoading = useTaskPaneLoading();
    const isLoading = paneLoading || locationLoading || !location;
    const toolkitDispatch = useToolkitDispatch();
    const selectedClientsAndLocations = useSelectedClientsAndLocations();
    const groups = useRegistersGroups();
    const dataPermissions = useUserDataPermissions();
    const anyClientPresent =
        selectedClientsAndLocations.filter((item) => !!item.clientId).length >
        0;

    useEffect(() => {
        if (!groups) {
            toolkitDispatch(fetchRegistersGroups({}));
        }
    }, [groups, toolkitDispatch]);

    const isAddLocationVisible = privileges.locations && anyClientPresent;

    const handleEdit = () => {
        toolkitDispatch(enterLocationEditMode());
    };

    const handleAdd = () => {
        toolkitDispatch(enterLocationAddMode());
    };

    const initialValues = {
        ...BLANK_FORM_LOCATION,
        ...location,
        visibilityType: prepareVisibilityType(
            groups,
            location?.groupIds,
            dataPermissions
        ),
        groups: prepareGroups(groups, location?.groupIds),
    };

    return (
        <>
            <PaneHeader
                onCloseClick={handleClose}
                title={TranslationHelper.translate('Location')}
                titleComponent={titleComponent}
                renderRightCustomControls={() => (
                    <>
                        {isAddLocationVisible && (
                            <IconButtonWithTooltip
                                title={TranslationHelper.translate('Add')}
                                onClick={handleAdd}
                            >
                                <AddIcon />
                            </IconButtonWithTooltip>
                        )}

                        {privileges.locations && (
                            <IconButtonWithTooltip
                                title={TranslationHelper.translate('Edit')}
                                onClick={handleEdit}
                            >
                                <EditIcon />
                            </IconButtonWithTooltip>
                        )}
                    </>
                )}
            />

            {isLoading ? (
                <LinearProgress />
            ) : (
                <LocationPreviewForm initialValues={initialValues} />
            )}
        </>
    );
};
export default LocationPane;
